// extracted by mini-css-extract-plugin
export default {"wrapper":"Task_wrapper__sZ4fJ","text":"Task_text__ru4z+","btn":"Task_btn__ZwW8-","checkbox":"Task_checkbox__C9DbF"};